import { Action, createReducer, on } from '@ngrx/store';
import { BookingState } from './booking.state';
import { adapter } from './booking.entity';
import { BookingFilter } from '../models/booking.filter';
import * as fromAction from './booking.action';
import { addDays, differenceInCalendarDays, formatISO, parseISO } from "date-fns";
import { Schedule } from "@modules/booking/models/scheduleRef";
import { ResetBookingStore } from './booking.action';

export const initialState: BookingState = adapter.getInitialState({
  error: null,
  totalCount: 0,
  pageIndex: 0,
  filter: new BookingFilter(),
  activeCount: 0,
  pendingCount: 0,
  upcomingCount: 0,
  historyCount: 0,
  isGuide:  null,
  serviceProviderView: false,
  serviceProviderId: '',
  isCourseBooked: false,
  participants: []
});

const reducer = createReducer(
  initialState,
  on(fromAction.AddBooking,fromAction.AddServiceBooking,(state, { booking }) => {
    return adapter.addOne(booking, state);
  }),
  on(fromAction.AddBookings, (state, { bookings }) => {
    return adapter.setAll(bookings, state);
  }),
  on(fromAction.AddMoreBookings, (state, { bookings }) => {
    return adapter.addMany(bookings, state);
  }),
  on(fromAction.UpdateBooking,fromAction.UpdateServiceBooking, (state, { id, change }) => {
    return adapter.updateOne({ id: id, changes: change }, state);
  }),
  on(fromAction.DeleteBooking,fromAction.DeleteServiceBooking, (state, { id }) => {
    return adapter.removeOne(id, state);
  }),
  on(fromAction.AddTotalCount, (state, { totalCount }) => {
    return adapter.addMany([], { ...state, totalCount: totalCount });
  }),
  on(fromAction.ActiveTotalCount, (state, { activeCount }) => {
    return adapter.addMany([], { ...state, activeCount: activeCount });
  }),
  on(fromAction.PendingTotalCount, (state, { pendingCount }) => {
    return adapter.addMany([], { ...state, pendingCount: pendingCount });
  }),
  on(fromAction.HistoryTotalCount, (state, { historyCount }) => {
    return adapter.addMany([], { ...state, historyCount: historyCount });
  }),
  on(fromAction.UpcomingTotalCount, (state, { upcomingCount }) => {
    return adapter.addMany([], { ...state, upcomingCount: upcomingCount });
  }),
  on(fromAction.AddError, (state, { error }) => {
    return adapter.addMany([], { ...state, error: error });
  }),
  on(fromAction.AddBookingFilter, (state, { filter }) => {
    return adapter.addMany([], { ...state, filter: filter });
  }),
  on(fromAction.RemoveBookingFilter, (state, {}) => {
    return adapter.addMany([], { ...state, filter: new BookingFilter() });
  }),
  on(fromAction.SetUserMode, (state, { isGuide }) => {
    return adapter.addMany([], { ...state, isGuide: isGuide });
  }),
  on(fromAction.SetServiceProviderId, (state, { serviceProviderId }) => {
    return ({ ...state,serviceProviderId: serviceProviderId });
  }),
  on(fromAction.SetServiceProviderView, (state, { serviceProviderView }) => {
    return ({ ...state, serviceProviderView: serviceProviderView });
  }),
  on(fromAction.AddBookingReview, (state, { review }) => {
    return adapter.updateOne(
      { id: review.bookingId, changes: { ...state.entities[review.bookingId], isReviewed: true } },
      state
    );
  }),
  on(fromAction.AddIsCourseBooked, (state, { isCourseBooked }) => {
    return adapter.addMany([], { ...state, isCourseBooked });
  }),
  on(fromAction.RemoveIsCourseBooked, (state) => {
    return adapter.addMany([], { ...state, isCourseBooked: false });
  }),
  on(fromAction.UpdateBookingReschedule, (state, { booking }) => {
    return adapter.updateOne({ id: booking.id, changes: booking }, state);
  }),
  on(fromAction.AddParticipants, (state, { participants }) => {
    return {...state, participants }
  }),
  on(fromAction.RemoveParticipants, (state) => {
    return {...state, participants: [] }
  }),
  on(fromAction.ActivateDigitalCourseBookingSuccess,(state, {bookingId}) => {
    return adapter.updateOne( {id: bookingId, changes: { activated: formatISO(new Date(),{format: 'extended', representation: 'complete'}) , schedule: { ...state.entities[bookingId].schedule, endDate: formatISO(addDays(new Date(), getScheduleDuration(state.entities[bookingId].schedule)),{format: 'extended', representation: 'complete'}) } }},state);
  }),
  on(fromAction.UpdatePageIndex, (state) => {
    return {...state, pageIndex: state.pageIndex + 1 };
  }),
  on(fromAction.ResetPageIndex, (state) => {
    return {...state, pageIndex: initialState.pageIndex};
  }),
  on(fromAction.UpdateBookingReviewState, (state, { serviceId }) => {
    return adapter.map(booking => booking.serviceRef.id === serviceId ? { ...booking, isReviewed: true } : booking, state);
  }),
  on(fromAction.ResetBookingStore, (state) => {
    return { ...initialState };
  })
);

export const getScheduleDuration = (schedule: Schedule) : number => {
  return differenceInCalendarDays(parseISO(schedule.endDate.toString()), parseISO(schedule.date.toString())) ?? 0;
}

export function bookingStoreReducer(state: BookingState = initialState, action: Action): BookingState {
  return reducer(state, action);
}
